import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestList.XeroMatchingV2Section.BillView.ChangeMatchingPopup.ChangeMatchingPopupEmpty',
    {
        emptyStateTitle: 'Choose PO to match with',
        emptyStateText: 'There are no Purchase Orders available for matching',
    }
);
